module.exports = __webpack_public_path__ + "img/facings-techniques.11f19a6f.jpg";